import { useBreakpointV2 } from "@tm/ui-widgets";
import React from "react";
import {
  Icon,
  MyraBorder,
  MyraContainer,
  MyraIconContainer,
  PersuasionText,
  PersuasionTextSpan,
  RightPersuasionTextWrapper,
} from "./ChatbotPersuasionText.style";

interface ChatbotPersuasionTextProps {
  src: string;
  onClick: () => void;
}

const ChatbotPersuasionText: React.FC<ChatbotPersuasionTextProps> = ({
  src,
  onClick,
}) => {
  const device = useBreakpointV2();
  return (
    <MyraContainer onClick={onClick} device={device}>
      <MyraIconContainer>
        <MyraBorder>
          <Icon>
            <img src={src} alt="Myra Animation" />
          </Icon>
        </MyraBorder>
        <RightPersuasionTextWrapper>
          <PersuasionText>
            <PersuasionTextSpan>Hey I am Myra</PersuasionTextSpan>
          </PersuasionText>
        </RightPersuasionTextWrapper>
      </MyraIconContainer>
    </MyraContainer>
  );
};

export default ChatbotPersuasionText;
